import { format } from 'date-fns';
import { aud } from '@/utils/format';
import type { CommissionArrangement } from '@/domain/types';

/** "60%", "flat $100", "owner-artist · 100%" — the one-line arrangement label. */
export function arrangementLabel(a: CommissionArrangement): string {
  switch (a.kind) {
    case 'percentage':
      return `${Math.round(a.artistShare * 100)}%`;
    case 'flat-day-fee':
      return `flat ${aud(a.feeAud)}`;
    case 'owner-artist':
      return 'owner-artist · 100%';
  }
}

/** A finish/sign time as "4:02pm", or a fallback when the artist is still working. */
export const finishTime = (iso?: string): string =>
  iso ? format(new Date(iso), 'h:mmaaa') : 'in chair';
